import { render, staticRenderFns } from "./Add_customer_point.vue?vue&type=template&id=6ccd063b&scoped=true&"
import script from "./Add_customer_point.vue?vue&type=script&lang=js&"
export * from "./Add_customer_point.vue?vue&type=script&lang=js&"
import style0 from "./Add_customer_point.vue?vue&type=style&index=0&id=6ccd063b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd063b",
  null
  
)

export default component.exports